/**
 * Product Media Carousel Component
 * Standalone version - uses window.Splide instead of imports
 */

if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super();

        this.childElements = [...this.children];
        this.childElements.forEach((child) => {
          child.classList.add('splide__slide');
        });
        this.slides = this.innerHTML;
        this.pagination = this.hasAttribute('pagination');
        this.useThumbnails = this.hasAttribute('thumbnails');

        this.generateCarousel = this.generateCarousel.bind(this);
      }

      connectedCallback() {
        this.generateCarousel();
      }

      generateCarousel() {
        this.innerHTML = '';

        let thumbnails = '';

        const mainSlider = document.createElement('div');
        mainSlider.classList.add('splide', 'lg:mb-16', 'mb-[38px]');
        const list = document.createElement('div');
        const track = document.createElement('div');
        list.classList.add('splide__list');
        track.classList.add('splide__track');
        list.innerHTML = this.slides;
        track.append(list);
        mainSlider.append(track);
        this.append(mainSlider);

        if (this.useThumbnails) {
          const thumbnailSlider = document.createElement('div');
          thumbnailSlider.classList.add('splide');
          const thumbList = document.createElement('div');
          const thumbTrack = document.createElement('div');
          thumbList.classList.add('splide__list', 'justify-center');
          thumbTrack.classList.add('splide__track');

          const thumbnailSlides = [...this.childElements].map((slide) => {
            const thumbSlide = slide.cloneNode(true);
            // remove badges from thumbnail slides
            const badges = thumbSlide.querySelectorAll(
              '.badge-text, .badge-image'
            );
            badges.forEach((badge) => badge.remove());

            // Replace videos with their poster image in thumbnails
            const video = thumbSlide.querySelector('video');
            if (video) {
              const posterUrl = video.poster || '';
              const videoContainer = video.closest('.video-media-container');
              if (videoContainer && posterUrl) {
                // Create an image element to replace the video
                const img = document.createElement('img');
                img.src = posterUrl;
                img.className = 'h-full w-full object-cover';
                img.alt = video.getAttribute('aria-label') || 'Video thumbnail';

                // Replace the entire video container content
                videoContainer.innerHTML = '';
                videoContainer.appendChild(img);
              }
            }

            thumbSlide.classList.remove('h-full', 'w-full');
            thumbSlide.classList.add(
              'w-[60px]',
              'h-[60px]',
              'opacity-50',
              'transition-opacity'
            );

            return thumbSlide;
          });

          thumbList.append(...thumbnailSlides);
          thumbTrack.append(thumbList);
          thumbnailSlider.append(thumbTrack);
          this.append(thumbnailSlider);

          thumbnails = new window.Splide(thumbnailSlider, {
            autoHeight: true,
            autoWidth: true,
            gap: 20,
            rewind: true,
            pagination: false,
            isNavigation: true,
            arrows: false,
            breakpoints: {
              1024: {
                gap: 10
              }
            }
          });
        }

        const main = new window.Splide(mainSlider, {
          arrows: true,
          pagination: this.pagination,
          autoWidth: true,
          perPage: 1,
          arrowPath:
            'M31 20.5 10.85 40 8 37.242 25.3 20.5 8 3.758 10.85 1l17.3 16.742L31 20.5Z',
          classes: {
            arrows: 'splide__arrows ',
            arrow: 'splide__arrow h-10 w-10 rounded-none opacity-100',
            prev: '-left-[2.25rem] splide__arrow--prev',
            next: '-right-[2.25rem] splide__arrow--next',
            pagination: 'splide__pagination media__pagination',
            page: 'splide__pagination__page media-page'
          },
          breakpoints: {
            1024: {
              arrows: true
            }
          }
        });

        if (this.useThumbnails) {
          main.sync(thumbnails);
        }

        // Handle video playback on slide change
        main.on('active', (Slide) => {
          // Pause all videos when switching slides
          const allVideos = this.querySelectorAll('video');
          allVideos.forEach((video) => {
            if (!video.paused) {
              video.pause();
            }
          });

          // Handle current slide video - Slide.slide is the DOM element
          const currentVideo = Slide?.slide?.querySelector('video');
          if (currentVideo) {
            const container = currentVideo.closest('.video-media-container');
            const isSilent = container?.dataset.isSilent === 'true';

            // Only autoplay silent videos (those marked as silent)
            if (isSilent) {
              currentVideo.play().catch(() => {
                // Fail silently if autoplay is blocked by browser
              });
            }
            // Videos with controls require user interaction to play
          }
        });

        main.mount();

        if (this.useThumbnails) {
          thumbnails.mount();
        }
      }
    }
  );
}
